import { creatorbase } from '@round/api';
import { useCampaignQueriesByIds, useInfinitePosts } from '@round/creatorbase-helpers/api-hooks';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import uniq from 'lodash/uniq';

export type PreviousCampaignsData = creatorbase.Post & {
    campaign: creatorbase.Campaign | null;
};

export default function usePreviousCampaigns(
    account: creatorbase.ClientInfluencerAccount | undefined | null,
    ordering: creatorbase.GetPostsParams['ordering']
) {
    const { selectedClientId } = useClientSelect();
    const baseEnabled = !!account?.influencer_account_id && !!selectedClientId;

    const infinitePosts = useInfinitePosts(
        {
            influencer_account_id: account?.influencer_account_id,
            status: 'live',
            page_size: 25,
            client_id: selectedClientId,
            ordering,
        },
        { enabled: baseEnabled }
    );

    const campaignIdsByPage =
        infinitePosts.data?.pages.map((page) => uniq(page.results.map((post) => post.campaign_id))) ?? [];
    const campaignQueries = useCampaignQueriesByIds(campaignIdsByPage, {
        clientId: selectedClientId,
        enabled: baseEnabled,
    });

    const posts: PreviousCampaignsData[] =
        infinitePosts.data?.pages.flatMap((page, pageIndex) => {
            const campaigns = campaignQueries[pageIndex]?.data?.results ?? [];
            return page.results.map((post) => {
                const campaign = campaigns.find((c) => c.id === post.campaign_id) ?? null;
                return { ...post, campaign };
            });
        }) ?? [];

    return {
        ...infinitePosts,
        posts,
    };
}
